<template>
    <sembo-footer v-if="showFooter" ref="footerElement"></sembo-footer>
</template>

<script lang="ts">
    import { computed, defineComponent, ref, watch } from 'vue';
    import { useRoute } from 'vue-router';
    import { applyFooterConfig, getFooterConfig } from '@/config/footerConfig';

    export default defineComponent({
        name: 'CompanyFooter',
        setup() {
            const route = useRoute();
            const footerElement = ref<HTMLElement | null>(null);

            const showFooter = computed(() => {
                const blackList = ['redirecting'];
                const name = route?.name ?? '';
                return !blackList.includes(name.toString());
            });

            const footerConfig = computed(() => {
                const routeName = route.name?.toString() ?? '';
                return getFooterConfig(routeName);
            });

            watch(
                () => route.name,
                () => {
                    if (footerElement.value) {
                        applyFooterConfig(footerElement.value, footerConfig.value);
                    }
                },
                { flush: 'post' }
            );

            watch(
                footerElement,
                (footer) => {
                    if (footer) {
                        applyFooterConfig(footer, footerConfig.value);
                    }
                },
                { immediate: true }
            );

            return {
                showFooter,
                footerElement,
            };
        },
    });
</script>
